import { useTranslation } from 'react-i18next';
import { interactionStatusRpmOptions } from 'constants/forms';

import BaseSelect from './base';

import type { Option } from './base';

interface Props<T extends string> {
  value?: Option<T> | null;
  onChange: (e: Option<T> | null) => void;
  allowClear?: boolean;
}

const InteractionStatusSelect = <T extends string>({
  onChange,
  value,
  allowClear,
}: Props<T>) => {
  const { t } = useTranslation();

  return (
    <BaseSelect
      label={t('labels.interactionStatus')}
      placeholder={t('labels.all')}
      data-cy="filter-interactionStatus"
      options={interactionStatusRpmOptions as Option<T>[]}
      value={value}
      onChange={(newValue) => {
        if (!newValue) {
          return onChange(null);
        }
        const items = Array.isArray(newValue) ? newValue : [newValue];
        onChange(items[0]);
      }}
      allowClear={allowClear}
    />
  );
};

export default InteractionStatusSelect;
